import React from "react";
import * as actions from './actions';

export default function OriginPopup({ eleRef }) {
    const items = [];
    const origin=[]
    for (const [index, value] of eleRef.entries()) {
        items.push(
            <div key={index} option={value.key}><span className="checkbox1" data-icon-font="z"></span><span className="checkbox2" data-icon-font="A"></span>{value.key}</div>
        );
        if(index < 100){
            origin.push(
                `'Origin_${index}':''`
            );
        }
    }
    return (
        <div className="origin_popup_overlay overlay" id="origin_popup_overlay" hidden>
            <div className="origin_popup filter_popups">
                <span className="M18_42">Please Select Origin</span>
               
                <ul>
                    <amp-selector multiple="" name="origin-selector[]" id="myorigin"
                    layout="container"
                    tabIndex="0" role="button"
                    on="select: AMP.setState({
                        allSelectedOrigin: event.selectedOptions,
                        allSelectedGender : genderapplied != 'true' ? 'Gender' : (allSelectedGender != '' ? allSelectedGender : 'Gender'),
                        allSelectedReligion : religionapplied != 'true' ? 'Religion' : (allSelectedReligion != '' ? allSelectedReligion : 'Religion'),
                        allSelectedRashi : rashiapplied != 'true' ? 'Rashi' : (allSelectedRashi != '' ? allSelectedRashi : 'Rashi')
                        })">
                        {items}
                    </amp-selector>
                </ul>
                <div className="action_buttons right">
                    <span tabIndex="0" role="button" className="M14_9e cancelfilterbtn" on="tap:origin_popup_overlay.hide,applyOrigin.clear, AMP.setState({'allSelectedOrigin': originapplied != 'true' ? 'Origin' : (allSelectedOrigin != '' ? allSelectedOrigin : 'Origin' ),
                    'allSelectedGender' : genderapplied != 'true' ? 'Gender' : (allSelectedGender != '' ? allSelectedGender : 'Gender'),
                    'allSelectedReligion' : religionapplied != 'true' ? 'Religion' : (allSelectedReligion != '' ? allSelectedReligion : 'Religion'),
                    'allSelectedRashi' : rashiapplied != 'true' ? 'Rashi' : (allSelectedRashi != '' ? allSelectedRashi : 'Rashi') })">CANCEL</span>
                    <span tabIndex="0" role="button" className="applyfilterbtn M14_pink" on="tap:origin_popup_overlay.hide, AMP.setState({'originapplied' : 'true'})">APPLY</span>
                    
                </div>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// src/shared/baby-names-amp/OriginPopup.js